module.exports = __webpack_public_path__ + "media/images/org-cultural-influence-icon-84819d6c.svg";